import {
  Checkbox,
  FormControlLabel,
  Grid2,
  IconButton,
  Typography,
} from "@mui/material";
import { useFormikContext } from "formik";
import React, { useCallback, useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import DeleteIco from "../../../../assets/icons/DeleteIco";
import DotsGrid from "../../../../assets/icons/DotsGrid";
import CommonButton from "../../../../component/Button";
import CommonTextField from "../../../../component/Input";
import { HandleSkeletion } from "../../../../utils/constants";
import { StyledFlexRowView } from "../../../common-components/StyledComponents";
import { CustomPaper } from "../../../resume-intelligence/Style";
import debounce from "lodash.debounce";

function SeededPreScreen({
  alignment,
  preScreen,
  onDragEnd,
  handleSeededDelete,
  isLoading,
  handleAddSeeded,
  onListChange,
  handleEnableDynamicCheckBox,
}) {
  const { values, errors, setFieldValue } = useFormikContext();
  const [hasDragged, setHasDragged] = useState(false);
  const [seededData, setSeededData] = useState(values["pre_screen_questions"]);
  useEffect(() => {
    setSeededData(values["pre_screen_questions"]);
  }, [values]);

  const handleListChange = (e, index) => {
    const updatedQuestions = [...values["pre_screen_questions"]];
    updatedQuestions[index] = e.target.value;

    setSeededData(updatedQuestions);

    debouncedOnListChange(updatedQuestions, "pre_screen_questions");
  };

  const debouncedOnListChange = useCallback(
    debounce((updated, key) => {
      onListChange(updated, key);
    }, 300),
    []
  );

  return (
    <Grid2 container spacing={3}>
      <Grid2 item size={12} marginTop={"1rem"}>
        <Typography variant={"body3"} color={"#101828"}>
          {"Seeded Pre-Screen Questions"}
        </Typography>
      </Grid2>
      <Grid2 item size={12}>
        {isLoading ? (
          Array.from({ length: 2 }).map((_, index) => (
            <HandleSkeletion height={60} />
          ))
        ) : (
          <DragDropContext
            onDragEnd={(event) => {
              setHasDragged(true);
              onDragEnd(event, setFieldValue, values);
              setTimeout(() => {
                setHasDragged(false);
              }, 50);
            }}
          >
            <Droppable droppableId="droppable-questions">
              {(provided) => (
                <Grid2
                  container
                  // spacing={2.5}
                  size={12}
                  {...provided?.droppableProps}
                  ref={provided.innerRef}
                >
                  {(alignment === "Edit" ? seededData : preScreen)?.map(
                    (question, index) => {
                      return (
                        <Draggable
                          draggableId={`drag-${index}`}
                          index={index}
                          key={`question-${index}`}
                        >
                          {(provided) => (
                            <Grid2
                              item
                              size={12}
                              key={index}
                              ref={provided.innerRef}
                              marginBottom={"1.2rem"}
                              {...provided?.draggableProps}
                            >
                              <StyledFlexRowView
                                gap="15px"
                                alignItems={"flex-start"}
                              >
                                {alignment === "View" ? (
                                  <CustomPaper
                                    variant="outlined"
                                    border="1px solid #D0D5DD !important"
                                    width="100%"
                                    padding={"10px 12px"}
                                    borderRadius="8px"
                                  >
                                    <Typography
                                      fontSize={"16px"}
                                      fontWeight={500}
                                      color={"#101828"}
                                    >
                                      {question}
                                    </Typography>
                                  </CustomPaper>
                                ) : (
                                  <CommonTextField
                                    placeholder={"Enter the Question"}
                                    padding="10px"
                                    error={Boolean(
                                      errors["pre_screen_questions"]?.[index]
                                    )}
                                    helperText={
                                      errors["pre_screen_questions"]?.[index]
                                    }
                                    {...(hasDragged
                                      ? { value: question }
                                      : { defaultValue: question })}
                                    defaultValue={question}
                                    onChange={(e) => {
                                      handleListChange(e, index);
                                    }}
                                  />
                                )}

                                <IconButton
                                  size="small"
                                  disabled={alignment === "View"}
                                  sx={{
                                    border: "1px solid #D0D5DD",
                                    borderRadius: "7px",
                                    padding: "10px",
                                    opacity: alignment === "View" ? 0.5 : 1,
                                  }}
                                  {...provided?.dragHandleProps}
                                >
                                  <DotsGrid />
                                </IconButton>

                                <IconButton
                                  size="small"
                                  disabled={alignment === "View"}
                                  sx={{
                                    border: "1px solid #D0D5DD",
                                    borderRadius: "7px",
                                    padding: "10px",
                                    opacity: alignment === "View" ? 0.5 : 1,
                                  }}
                                  onClick={() =>
                                    alignment === "View"
                                      ? {}
                                      : handleSeededDelete(
                                          question,
                                          index,
                                          values
                                        )
                                  }
                                >
                                  <DeleteIco />
                                </IconButton>
                              </StyledFlexRowView>
                            </Grid2>
                          )}
                        </Draggable>
                      );
                    }
                  )}

                  {provided?.placeholder}
                </Grid2>
              )}
            </Droppable>
          </DragDropContext>
        )}
        {alignment !== "View" && (
          <Grid2 item size={12} marginBottom={"1rem"}>
            <CommonButton
              variant="outlined"
              color="#344054"
              border="#D0D5DD"
              fontWeight="600"
              value={"Add Questions"}
              disabled={isLoading}
              onClick={() => handleAddSeeded(values)}
              padding="10px 20px"
            />
          </Grid2>
        )}
        <Grid2 size={{ xs: 12 }}>
          <FormControlLabel
            sx={{ margin: "0px" }}
            control={
              <Checkbox
                checked={values.enable_dynamic_pre_screen_questions}
                onChange={handleEnableDynamicCheckBox}
              />
            }
            label="Enable Dynamic Pre Screen Questions"
          />
        </Grid2>
      </Grid2>
    </Grid2>
  );
}

export default SeededPreScreen;
